import { render } from "./AuthenticationActivate.vue?vue&type=template&id=3381deaf&scoped=true"
import script from "./AuthenticationActivate.vue?vue&type=script&lang=js"
export * from "./AuthenticationActivate.vue?vue&type=script&lang=js"

import "./AuthenticationActivate.vue?vue&type=style&index=0&id=3381deaf&scoped=true&lang=css"

import exportComponent from "/home/falken/code/web/ipronet-vsaas/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3381deaf"]])

export default __exports__